import React from "react";
import { useTranslation } from 'react-i18next';

interface OnboardingWelcomeModalProps {
    isOpen: boolean;
    userName?: string;
    onGetStarted: () => void;
}

const OnboardingWelcomeModal: React.FC<OnboardingWelcomeModalProps> = ({ isOpen, userName, onGetStarted }) => {
    const { t } = useTranslation();
    
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50" style={{ backgroundColor: 'rgba(0, 0, 0, 0.90)' }}>
            <div className="bg-white rounded-2xl shadow-xl p-8 sm:p-12 w-full max-w-4xl mx-4 relative">
                <div className="text-center px-4 py-6 sm:px-8">
                    <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
                        {t('onboarding.welcome_title', { name: userName || '' })}
                    </h2>
                    <p className="mt-4 text-gray-600 max-w-2xl mx-auto text-xl leading-relaxed">
                        {t('onboarding.welcome_message')}
                    </p>
                    <div className="mt-8 bg-gray-50 border border-gray-200 rounded-xl p-8 text-gray-700 max-w-3xl mx-auto">
                        <p className="text-lg leading-relaxed">
                            {t('onboarding.configure_intro')}
                        </p>
                        <p className="mt-4 text-base text-gray-500">
                            {t('onboarding.configure_hint')}
                        </p>
                    </div>

                    <button
                        className="mt-10 inline-flex items-center justify-center px-12 py-4 rounded-full bg-[#64BE78] text-white text-xl sm:text-2xl font-bold hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all duration-200 transform hover:scale-105"
                        onClick={onGetStarted}
                    >
                        {t('onboarding.get_started')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default OnboardingWelcomeModal;


